module.exports = __webpack_public_path__ + "img/icon-meteo-1@2x.9af3dcd1.png";